@if (modelGroup?.HasForms || bagmode) {
  <div class="forms-group">
    @for (ms of modelSizes; track ms) {
      <div>
        <checkbox [disabled]="disabled(hasFixtures, ms)" (checkedChange)="setForms(ms, $event)" [checked]="ms.Uuid === modelSize?.Uuid && hasForms" [label]="'FORMS.NAME' | translate: {modelSize: ms.Hbox}"></checkbox>
      </div>
    }
  </div>
}
@if (modelGroup?.HasFixtures) {
  <div class="fixtures-group">
    @for (ms of modelSizes; track ms) {
      <div>
        <checkbox [disabled]="disabled(hasForms, ms)" (checkedChange)="setFixtures(ms, $event)" [checked]="ms.Uuid === modelSize?.Uuid && hasFixtures" [label]="'FIXTURE.NAME' | translate: {modelSize: ms.Hbox}"></checkbox>
      </div>
    }
  </div>
}